// extracted by mini-css-extract-plugin
export default {"container":"Label_container__3dCq7","label":"Label_label__Hss0Z","explanation":"Label_explanation__UFZOW"};